import frLang from 'element-ui/lib/locale/lang/fr'
const messages = {
  ...frLang,
  "banner1": "La marque Solplanet est un développement d'AISWEI",
  "banner2": "anciennement SMA Chine",
  "banner3": "Le solaire pour tous",
  "english": "En anglais",
  "polish": "Polonais",
  "spanish": "Espagnol",
  "germany": "Allemand",
  "turkish": "Turc",
  "french": "Français",
  "italian": "Italien",
  "systemData1": "Le système",
  "installationLocation1": "Installation",
  "customerData1": "Client",
  "claimData": "Réclamation",
  "shippingAddress1": "Expédition",
  "customerData": "Données sur les client",
  "customerType": "Type de client",
  "selectCustomer": "Veuillez sélectionner le type de demandeur",
  "--None--": "--None--",
  "Installer": "Installateur",
  "End-customer": "Client final",
  "Distributor": "Distributeur",
  "EPC": "EPC",
  "Other": "Autre",
  "companyName": "Nom de l'entreprise",
  "typeCompanyName": "Veuillez saisir le nom de l'entreprise",
  "contacts": "Nom du contact",
  "typeContacts": "Veuillez saisir le nom de la personne à contacter",
  "contactInformation": "Numéro de téléphone",
  "typeContactInformation": "Veuillez saisir votre numéro de téléphone",
  "shippingAddress": "Adresse d'expédition (Veuillez noter que cette adresse servira d'adresse d'expédition en cas d'échange)",
  "country": "Pays/Région",
  "typeCountry": "Veuillez saisir le pays/la région",
  "province": "Provinces",
  "typeProvince": "Veuillez saisir l'provinces",
  "city": "Ville",
  "typeCity": "Veuillez saisir la ville",
  "area": "Rue",
  "typeArea": "Veuillez indiquer l'adresse complète (jusqu'au numéro de maison)",
  "contacts01": "Téléphone portable",
  "typeContacts01": "Veuillez saisir votre téléphone portable",
  "postCode": "Code postal",
  "typePostCode": "Veuillez saisir le code postal",
  "email": "Courriel",
  "typeEmail": "Veuillez saisir votre adresse électronique",
  "errorEmail": "Veuillez saisir une adresse e-mail valide.",
  "installationLocation": "Lieu d'installation (utiliser l'adresse de livraison)",
  "purchaseDate": "Date d'achat",
  "typePurchaseDate": "Veuillez indiquer la date d'achat",
  "installDate": "Date d'installation",
  "typeInstallDate": "Veuillez saisir la date d'installation",
  "faultyDeviceType": "Défaut Type d'appareil",
  "selectFaultyDeviceType": "Veuillez sélectionner le type d'appareil défectueux",
  "faultDate": "Date de la panne",
  "typeFaultDate": "Veuillez saisir la date de l'erreur",
  "deviceSerialNumber": "Numéro de série de l'appareil",
  "typeDeviceSerialNumber": "Veuillez saisir le numéro de série de l'appareil",
  "faultySymptom": "Type de défectuosité",
  "selectFaultySymptom": "Veuillez sélectionner le type de défectuosité",
  "errorDescription": "Description détaillée de l'erreur",
  "typeErrorDescription": "Veuillez saisir une description détaillée de l'erreur",
  "purchaseFileId": "Preuve d'achat (pièce jointe)",
  "purchaseDesc": "La preuve d'achat doit comporter le nom du client, l'adresse d'installation, le modèle d'onduleur et le fait qu'elle a été payée",
  "breakFileId": "Certificat d'échec (pièce jointe)",
  "breakDesc": "Veuillez soumettre une photo du détail du défaut, le message d'erreur et l'autocollant du numéro de série du produit",
  "upload": "Télécharger",
  "systemData": "Données du système (en option)",
  "systemData01": "S'agit-il de la première demande via ce portail de demande de garantie?",
  "Yes": "Oui",
  "No": "Non",
  "Unknown": "Inconnu",
  "systemData02": "État de fonctionnement d'autres onduleurs sur le même site",
  "systemData03": "Motif de la demande antérieure",
  "enterSystemData03": "Veuillez indiquer la raison de la demande antérieure",
  "systemData04": "Détail des défauts des autres onduleurs sur le même site",
  "enterSystemData04": "Veuillez indiquer les détails des défauts d'autres onduleurs sur le même site",
  "systemData05": "Conditions environnementales de l'installation du variateur",
  "systemData0501": "Intérieur",
  "systemData0502": "En extérieur (sous le site ombragé du bâtiment ou monter un auvent)",
  "systemData0503": "Extérieur (exposition de l'onduleur à la lumière directe du soleil)",
  "systemData0504": "Au-dessus de l'eau",
  "systemData0505": "Autres",
  "systemData06": "Conditions environnementales de l'installation des panneaux solaires",
  "systemData0601": "Sur le terrain",
  "systemData0602": "Sur le toit",
  "systemData0603": "A la surface de l'eau",
  "systemData0604": "Autres",
  "systemData07": "Marque et modèle du  panneau solaire",
  "typeSystemData07": "Veuillez indiquer la marque et le modèle du panneau solaire",
  "systemData08": "Mode PV",
  "systemData0801": "Indépendants",
  "systemData0802": "Parallèle",
  "pleaseSelect": "Veuillez sélectionner",
  "add": "Ajouter",
  "delete": "Supprimer",
  "pv10": "panneau solaire à cordes (pièces)",
  "pv101": "Panneau solaire PV1string (pièces)",
  "pv102": "Panneau solaire PV2string (pièces)",
  "pv103": "Panneau solaire PV3string (pièces)",
  "pv104": "Panneau solaire PV4string (pièces)",
  "circuit01": "tension en circuit ouvert (V)",
  "alternatingVoltage": "Tension AC",
  "l1l2": "Tension AC L1 - L2(V)",
  "l1n": "Tension AC L1 - N(V)",
  "l2l3": "Tension AC L2 - L3(V)",
  "l2n": "Tension AC L2 - N(V)",
  "l1l3": "Tension AC L1 - L3(V)",
  "l3n": "Tension AC L3 - N(V)",
  "l1pe": "Tension AC L1 - PE(V)",
  "l3pe": "Tension AC L3 - PE(V)",
  "l2pe": "Tension AC L2 - PE(V)",
  "npe": "Tension AC N - PE(V)",
  "complaintFileId": "Pièce jointe",
  "activeTip": "Notice：Plus vous fournirez d'informations détaillées sur l'installation, plus vite nous pourrons identifier le problème",
  "submitBtn": "Soumettre",
  "pleaseType": "Veuillez entrer",
  "submitSuccess": "Soumettre le succès",
  "submitDesc": "Certains champs obligatoires ne sont pas remplis, veuillez les soumettre à nouveau après confirmation. Merci !",
  "typeUpload": "Veuillez télécharger",
  "resetUpload": "Reupload",
  "selectErrorMessage": "Veuillez sélectionner le message d'erreur",
  "errorMessage": "Autre",
  "MPPT": "MPPT",
  "chinese": "Chinois",
  "dutch": "Néerlandais",
  "hungary": "Hongrie",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "J'accepte les conditions générales de Solplanet",
  "iagree": "J'accepte les conditions générales de Solplanet",
  "language": "Langue",
  "ptbr": "Portugais (Brésil)",
  "zhtw": "Chinois traditionnel",
  "documentTitle": "Garantie │Solplanet",
  "validateNumber": "Veuillez saisir un nombre entier"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/french.js